// extracted by mini-css-extract-plugin
export default {"container":"PgYhkO","input":"nM7GFG","label":"R71Ncd","removeButton":"kHLy_G"};